/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";

export default class HelpNote extends BaseCom {
    render() {
        return <div className="small fst-italic">{this.props.children}</div>;
    }
}